import { ApplicationRoute } from "../../routing/routes";
import { IFeatureFlagHookResult } from "./hooks/useFeatureFlag";

export type IFeatureFlag = "sdf_overview_page" | "bulk_actions" | "risk_groups";

export const routePermittedByFeatureFlag =
  <T extends IFeatureFlag>(defs: Record<T, IFeatureFlagHookResult>) =>
  (route: ApplicationRoute) =>
    defs[route.featureFlag as unknown as T]?.enabled ?? true;
